import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  Renderer2,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  encapsulation: ViewEncapsulation.None,
  host: { class: 'pulse-icon' },
  selector: 'pulse-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
})
export class IconComponent implements OnInit, OnChanges {
  @Input() icon = 'home';
  @Input() color = 'black';
  @Input() size: any = '22';

  private currentClass: any;

  constructor(
    private readonly element: ElementRef,
    private readonly renderer: Renderer2
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['icon'] && !changes['icon'].firstChange) {
      this.renderIcon();
    }
  }

  ngOnInit(): void {
    this.renderIcon();
  }

  renderIcon() {
    this.renderer.addClass(this.element.nativeElement, `icon-${this.icon}`);
    this.renderer.addClass(
      this.element.nativeElement,
      `text-${this.color}-500`
    );
    this.renderer.removeClass(
      this.element.nativeElement,
      `icon-${this.currentClass}`
    );
    this.renderer.setStyle(
      this.element.nativeElement,
      'font-size',
      `${this.size}px`
    );
    this.currentClass = this.icon;
  }
}
